import { Component } from '@angular/core';
import { Service } from '../service';
import { FCToasterService } from '../common/toaster/FCToasterService';
import { GridOptions } from 'ag-grid-community';
import { UnitSync } from '../common/models/unitSync';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from '../services/master-data.service';

@Component({
    selector: 'app-unit-info',
    templateUrl: './unit-info.component.html',
    styleUrls: ['./unit-info.component.scss'],
    standalone: false
})
export class UnitInfoComponent {
gridOptions: GridOptions;
txtUnitSrch: string;
unitlist: any[];
rowData: any[];
columnDefs: any[];
disableSync: boolean = true;
unitSyncInfo = {} as UnitSync;
selectedFileTypeId: number;
fileTypes: any[];
filteredFileTypes: any[];
filteredRowData: any[] = [];
closeResult: string;

constructor(private apiService: Service,private toastr: FCToasterService,private modalService: NgbModal, private masterDataService: MasterDataService) {}
  ngOnInit(): void {
    this.gridOptions = {            
      defaultColDef: { filter: false },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: false,
      paginationAutoPageSize: false,
      headerHeight: 40,
      rowHeight: 32
    }        
    this.unitlist = [];    
    this.bindGridOnPageLoad();
    this.onResetFilters();  
    this.getFileTypes();
    this.selectedFileTypeId = 1;
  }

  bindGridOnPageLoad() {
    this.columnDefs = [
      { headerName: "File Id", field: "fileId", sortable: true, minWidth: 140, flex: 1.4, tooltipField: "fileId", headerTooltip: "File Id" },
      { headerName: "Unit Number", field: "elevatorUnitNumber", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "elevatorUnitNumber", headerTooltip: "Unit Number" },
      { headerName: "Building Id", field: "buildingId", sortable: true, minWidth: 170, flex: 1.7, resizable: true, tooltipField: "buildingId", headerTooltip: "Building Id" },      
      { headerName: "Building Name", field: "buildingName", sortable: true, minWidth: 300, flex: 3, tooltipField: "buildingName", headerTooltip: "Building Name" },
      { headerName: "Building Address", field: "buildingAddress", sortable: true, minWidth: 350, flex: 3.5, resizable: true, tooltipField: "buildingAddress", headerTooltip: "Building Address" },
      { headerName: "City", field: "city", sortable: true, minWidth: 200, flex: 2, resizable: true, tooltipField: "city", headerTooltip: "City" },
      { headerName: "Postal Code", field: "pincode", sortable: true, minWidth: 220, flex: 2.2, resizable: true, tooltipField: "pincode", headerTooltip: "Postal Code" },
      { headerName: "State", field: "state", sortable: true, minWidth: 250, flex: 2.5, resizable: true, tooltipField: "state", headerTooltip: "State" },      
      { headerName: "State ShortCode", field: "stateShortCode", sortable: true, minWidth: 250, flex: 2.5, resizable: true, tooltipField: "stateShortCode", headerTooltip: "State ShortCode" },      
      { headerName: "Country Code", field: "countryCode", sortable: true, minWidth: 250, flex: 2.5, resizable: true, tooltipField: "countryCode", headerTooltip: "Country Code" }          
    ];
    this.rowData = [];
  }

  open(content) {    
    this.modalService.open(content, { windowClass: "eloUpdateStyle", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });    
}

// Close Modal Popup
getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}

getFileTypes() {
    this.masterDataService
      .getFileType()
      .subscribe((data: any) => {
        this.fileTypes = this.filteredFileTypes = data;
      });
  }

  fileTypeSelectChanged($event){
    this.selectedFileTypeId = $event.target.value;
  }

  getUnitSearch(){
    if(this.txtUnitSrch != null && this.txtUnitSrch != undefined && this.txtUnitSrch.trim() != "")
    {
      this.apiService
        .getUnitSyncInfo(this.txtUnitSrch)
        .subscribe((data: any) => {
          if (data != null && data.length > 0) {
            this.rowData = this.filteredRowData = data;      
            if(this.rowData.length == 1)
            {
              this.filteredFileTypes = this.fileTypes.filter(x=>x.id == this.rowData[0]["fileTypeId"]);
              this.selectedFileTypeId = this.filteredFileTypes[0]['id'];
            }
            else{
              this.filteredFileTypes = this.fileTypes;
              this.filteredRowData = this.rowData.filter(x=> x.fileTypeId == this.selectedFileTypeId);            
            }
            this.disableSync = false;                           
          }
          else {
            this.rowData = [];
            this.toastr.showError("Couldn’t find the Unit Number in FC. Please upload the File before Unit Sync");
          }}, (error) => {
            this.clearGrid();          
        });
      }
      else{
        this.toastr.showError("Please enter Unit Number");
      }
  }

  onResetFilters(){
    this.txtUnitSrch = "";
    this.selectedFileTypeId = 1;
    this.clearGrid();  
    this.filteredFileTypes = this.fileTypes;
  }
  
  clearGrid()
  {
    this.rowData = [];
    this.filteredRowData = [];
    this.disableSync = true;
  }
  onKeyEnter(){
    this.getUnitSearch();
  }

  onUnitSync()
  {
    let lblctrl = document.getElementById('btnClose') as HTMLElement;
    lblctrl.click();
    this.unitSyncInfo.elevatorUnitNumber = this.txtUnitSrch;
    this.unitSyncInfo.fileType = this.selectedFileTypeId;
    this.apiService
      .unitSyncInfo(this.unitSyncInfo)
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.rowData = [];
            this.toastr.showSuccess("Unit Processed Successfully into FC backend!!");  
            this.onResetFilters();                                
          }
          else {
            this.toastr.showError("Failed to Sync Unit");
          }
        },
        error: () => {
        }
      });    
  }
}
